"use client";

import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";

import { generateId } from "@repo/bi/id";

import { withBasePath } from "@/lib/base-path";

import { inferPageType } from "./infer-page-type";
import { useSetVisitId } from "./visit-context";

export function TrackVisit() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const setVisitId = useSetVisitId();
  const isFirstRender = useRef(true);

  useEffect(() => {
    const pageType = inferPageType(pathname);
    if (!pageType) return;

    const visitId = generateId();

    document.cookie = `bi_visit_id=${visitId}; path=/; samesite=lax`;
    setVisitId(visitId);

    const url = searchParams.toString()
      ? `${pathname}?${searchParams.toString()}`
      : pathname;

    fetch(withBasePath("/api/bi/visit"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        url,
        pageType,
        referrerUrl: isFirstRender.current
          ? document.referrer || undefined
          : undefined,
      }),
      keepalive: true,
    }).catch(() => {});

    isFirstRender.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, searchParams]);

  return null;
}
